export const HEADER_BLOSSOM_ORIGIN = 'X-Blossom-Origin'

export const VALUE_BLOSSOM_ORIGIN_PARENT_APP = 'ParentApp'
